module.exports = __webpack_public_path__ + "static/img/349.51f0724.png";